<template>
  <div class="management">
    <div class="management-box">
      <div class="management-content">
        <div class="management-content-left">
          <div class="management-content-one">配置服务 \ 录入服务</div>
          <div class="management-content-two">档案整理服务</div>
          <div
            class="management-content-four"
            style=" margin-top: 30px;"
          >专为各地征收办服务，搭配征拆系统，提供旧档案整理录入服</div>
          <div class="management-content-four">务，纸质档案至电子档案的转换，一步到位。</div>
        </div>
        <div class="management-content-right">
          <img src="../assets/img/dangan.png" />
        </div>
      </div>
    </div>
    <div class="management-content-box">
      <div class="management-one">
        <div class="management-one-left" id="wrapper-text">
          <div class="management-text-one">历史档案配置</div>
          <div class="management-text-two">Historical file configuration</div>
          <div class="management-text-three" style="margin-top:30px">购买相关征拆系统后，由技术支持人员根据历史</div>
          <div class="management-text-three">档案需求配置系统表单。</div>
        </div>
        <div class="management-one-right" id="wrapper-img">
          <img src="../assets/img/dangan_02.png" />
        </div>
      </div>
      <div class="management-two">
        <div class="management-one-left" id="wrapper-text1">
          <div class="management-text-one">历史档案整理录入</div>
          <div class="management-text-two">Historical file sorting and entry</div>
          <div class="management-text-three" style="margin-top:30px">客户提供历史档案打包照片后，根据要求将历史</div>
          <div class="management-text-three">数据及相关照片录入征拆系统形成电子档案。</div>
        </div>
        <div class="management-one-right" id="wrapper-img1">
          <img src="../assets/img/dangan_03.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    var x = document.getElementById('wrapper-img');
    x.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight management-one-right'
    );
    var y = document.getElementById('wrapper-text');
    y.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft management-one-left'
    );
    var x1 = document.getElementById('wrapper-img1');
    x1.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight management-one-right'
    );
    var y1 = document.getElementById('wrapper-text1');
    y1.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft management-one-left'
    );
  }
};
</script>
<style>
.management {
  width: 100%;
}
.management-box {
  display: flex;
  width: 100%;
  height: 650px;
  background: url('../assets/img/blue.png') no-repeat center;
  background-size: 100% 650px;
  overflow: hidden;
}
.management-content {
  display: flex;
  width: 1500px;
  height: 650px;
  margin: auto;
  overflow: hidden;
}
.management-content-left {
  width: 50%;
  margin-top: 70px;
}
.management-content-one {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 24px;
  color: #ffffff;
}
.management-content-two {
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 60px;
  color: #ffffff;
  margin-top: 34px;
}
.management-content-three {
  margin-top: 20px;
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 72px;
  color: #ffffff;
}
.management-content-four {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  color: #ffffff;
  line-height: 40px;
}
.management-content-right {
  width: 50%;
}
.management-content-right img {
  width: 100%;
}
.management-content-box {
  width: 1500px;
  margin: auto;
  overflow: hidden;
}
.management-one,
.management-two,
.management-three {
  display: flex;
  padding: 50px 80px;
  overflow: hidden;
}
.management-text-one {
  margin-top: 96px;
  font-family: 微软雅黑;
  font-weight: 400;
  font-style: normal;
  font-size: 48px;
  color: rgb(73, 83, 98);
}
.management-text-two {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 30px;
  color: #999999;
}
.management-text-three {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 28px;
  color: #495362;
  line-height: 50px;
}
.management-one-left,
.management-one-right {
  width: 50%;
}
.management-one-right img {
  width: 100%;
  /* margin-top: 50px; */
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .management-content,
  .management-content-box {
    width: 1200px !important;
  }
  .management-content-two {
    font-size: 48px !important;
  }
  .management-one-left {
    padding-right: 30px !important;
  }
  .management-text-one {
    font-size: 36px !important;
  }
  .management-text-two {
    font-size: 28px !important;
  }
  .management-text-three {
    font-size: 24px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/file-management.vue